"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import { LitElement, html } from "lit";
import { property, state } from "lit/decorators.js";
import { STCComponentMixin } from "../../../common/mixins/stc_component_mixin";
const template = {
  render() {
    return (coupon) => {
      return html`
        <li kind="no-dot">
          <coupon-item .coupon=${coupon}></coupon-item>
        </li>
      `;
    };
  }
};
export class CouponCodesList extends STCComponentMixin(LitElement) {
  constructor() {
    super(...arguments);
    this.coupons = [];
    this.type = {
      fields: {
        row_1: {
          name: "row_1",
          title: "",
          render_type: "text"
        },
        row_2: {
          name: "row_2",
          title: "",
          render_type: "text"
        },
        row_3: {
          name: "row_3",
          title: "",
          render_type: "text"
        }
      },
      mutations: {
        page_index: 0
      }
    };
    this.settings = {
      subtitle: "Applicable Coupon Codes",
      labels: {
        global_search: "Search Applicable Coupon Codes"
      },
      hidden: {
        add_row: true,
        clear_all_limits: true
      },
      messages: {
        state_empty: {
          title: "No Coupon Codes",
          description: "If you have selected a Payment Category, then there are currently no applicable coupon codes."
        }
      }
    };
  }
  connectedCallback() {
    super.connectedCallback();
    this.fetchCoupons();
  }
  fetchCoupons() {
    const data = this.getAttribute("data-coupons");
    if (data) {
      this.coupons = JSON.parse(data);
    }
  }
  render() {
    return html`
      <vi-list
        class="mt-8"
        mode="item"
        .type=${this.type}
        .settings=${this.settings}
        .input=${this.coupons}
        .template=${template}
        style="--list--min-height: 9rem; --list--max-height: 9rem;"
      >
      </vi-list>
    `;
  }
}
__decorateClass([
  state()
], CouponCodesList.prototype, "coupons", 2);
customElements.define("coupon-codes-list", CouponCodesList);
class CouponItem extends LitElement {
  createRenderRoot() {
    return this;
  }
  render() {
    return html`
      <div class="pa-3">
        <hi-text class="text-sz-m text-bold">${this.coupon.row_1}</hi-text><br>
        <hi-text class="text-sz-m">${this.coupon.row_2}</hi-text><br>
        <hi-text class="text-sz-m">${this.coupon.row_3}</hi-text>
      </div>
    `;
  }
}
__decorateClass([
  property()
], CouponItem.prototype, "coupon", 2);
customElements.define("coupon-item", CouponItem);
